import request from "@/utils/request";



export const uploadAppVersion = (data: FormData) =>
    request({
        headers: {"Content-Type": "multipart/form-data"},
        url: "/mobile-versions/oss-url",
        method: "post",
        data: data
    });

export const createAppVersion = (data: any) =>
    request({
        url: "/mobile-versions",
        method: "post",
        data: data
    });

export const getAppVersion = (params: any) =>
    request({
        url: "/mobile-versions",
        method: "get",
        params
    });

export const deleteVersion = (data: any) =>
    request({
        url: "/mobile-versions",
        method: "delete",
        data: data
    });

export const updatePattern = (id: string,data: any) =>
    request({
        url: `/mobile-versions/${id}`,
        method: "post",
        data: data
    });